module.exports = __webpack_public_path__ + "img/guyana.2ecaea30.svg";